import { useState } from "react";

// usePaginationState.js
export default function usePaginationState() {
  const [entries, setEntries] = useState("5");
  const [pageNo, setPageNo] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [totalCount, setTotalCount] = useState();
  const [searchCount, setSearchCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");
 


  return {
    entries,
    setEntries,
    pageNo,
    setPageNo,
    searchInput,
    setSearchInput,
    totalCount,
    setTotalCount,
    searchCount,
    setSearchCount,
    prevSearch,
    setPrevSearch,
  };
}
